import PropTypes from "prop-types"

const ContactSequence = ({ priority = null, size = "sm" }) => {
  const classesBySize = {
    sm: "h-7 w-7",
    md: "h-8 w-8",
    lg: "h-11 w-11",
  }

  return (
    <div className={`text-background font-semibold text-[14px] rounded-full flex items-center justify-center text-center ${classesBySize[size]} ${priority === 1 ? "bg-green-400" : "bg-gray-400"}`}>
      {priority || "?"}
    </div>
  )
}

ContactSequence.propTypes = {
  priority: PropTypes.number,
  size: PropTypes.string,
}

export default ContactSequence